import { KeyboardEvent, useEffect, useState } from 'react';
import socket from '@/components/util/socket';
import Chat from '../../video/Chat';

type AvatarChatProps = {
  avatar: any;
  chatOpen: boolean;
  toggleChatClick: () => void;
  setNotifications: () => void;
};

export const AvatarChat = ({
  avatar,
  chatOpen,
  toggleChatClick,
  setNotifications,
}: AvatarChatProps) => {
  const [messages, setMessages] = useState([]);
  const [currentUserId, setCurrentUserId] = useState(null);

  useEffect(() => {
    socket.on('video_chat_receive', (message) => {
      message.timestamp = new Date();

      setMessages((prevMessages) => [...prevMessages, message]);
      if (!chatOpen) {
        setNotifications();
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (socket && socket.connected) setCurrentUserId(socket.id);
  }, []);

  return (
    <Chat
      currentUserId={currentUserId}
      toggleChatClick={toggleChatClick}
      chatOpen={chatOpen}
      messages={messages}
      onSubmit={(e: KeyboardEvent<HTMLInputElement>, message) => {
        socket.emit('video_chat_send', {
          name: avatar.name,
          text: message,
          avatarImage: avatar.imageUrl,
        });
      }}
    />
  );
};
